export interface Feedback {
  appropriateContent: {
    isAppropriate: boolean;
    reason?: string;
  };

  category: {
    isCorrect: boolean;
    newCategories?: string[];
    reason?: string;
  };

  comprehensibleContent: {
    isComprehensible: boolean;
    reason?: string;
  };

  type: {
    isCorrect: boolean;
    newType?: string;
    reason?: string;
  };

  link: {
    isCorrect: boolean;
    reason?: string;
  };

  image: {
    isAppropriate: boolean;
    reason?: string;
  };

  finalDecision?: 'APPROVE' | 'REJECT' | 'REQUEST_MODIFICATION';
  rejectionReason?: string;
}

export class FeedbackResponse {
  changedAt: string;
  comment: string | null;
  creation: number;
  id: string;
  newStatus: string;
  offerId: string;
  updated: number;
  feedback: {
    categoryReason: string;
    contentAppropriateReason: string;
    contentComprehensibleReason: string;
    creation: number;
    finalDecision: 'APPROVE' | 'REJECT' | 'REQUEST_MODIFICATION';
    id: string;
    imageReason: string;
    isCategoryCorrect: boolean;
    isContentAppropriate: boolean;
    isContentComprehensible: boolean;
    isImageAppropriate: boolean;
    isLinkCorrect: boolean;
    isTypeCorrect: boolean;
    linkReason: string;
    newCategories: string[];
    newType: string;
    offerId: string;
    rejectionReason: string;
    typeReason: string;
    updated: number;
  } | null;

  constructor(data: FeedbackResponse) {
    this.changedAt = data.changedAt;
    this.comment = data.comment;
    this.creation = data.creation;
    this.feedback = data.feedback;
    this.id = data.id;
    this.newStatus = data.newStatus;
    this.offerId = data.offerId;
    this.updated = data.updated;
  }

  get changedAtDate(): Date {
    return new Date(this.changedAt);
  }

  get convertedFeedback(): Feedback {
    return {
      appropriateContent: {
        isAppropriate: this.feedback?.isContentAppropriate ?? false,
        reason: this.feedback?.contentAppropriateReason ?? '',
      },
      category: {
        isCorrect: this.feedback?.isCategoryCorrect ?? false,
        newCategories: this.feedback?.newCategories ?? [],
        reason: this.feedback?.categoryReason ?? '',
      },
      comprehensibleContent: {
        isComprehensible: this.feedback?.isContentComprehensible ?? false,
        reason: this.feedback?.contentComprehensibleReason ?? '',
      },
      type: {
        isCorrect: this.feedback?.isTypeCorrect ?? false,
        newType: this.feedback?.newType ?? '',
        reason: this.feedback?.typeReason ?? '',
      },
      link: {
        isCorrect: this.feedback?.isLinkCorrect ?? false,
        reason: this.feedback?.linkReason ?? '',
      },
      image: {
        isAppropriate: this.feedback?.isImageAppropriate ?? false,
        reason: this.feedback?.imageReason ?? '',
      },
      finalDecision: this.feedback?.finalDecision,
      rejectionReason: this.feedback?.rejectionReason ?? '',
    };
  }
}
